import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=1886bbe2&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=1886bbe2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886bbe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1886bbe2')) {
      api.createRecord('1886bbe2', component.options)
    } else {
      api.reload('1886bbe2', component.options)
    }
    module.hot.accept("./AppBar.vue?vue&type=template&id=1886bbe2&scoped=true", function () {
      api.rerender('1886bbe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/AppBar.vue"
export default component.exports